<template>
  <b-overlay :show="loading">
    <div class="ml-2 mb-2 font-weight-bold">
      <b-link to="/drilldowns"><b-icon icon="chevron-left"></b-icon>5-Minute Drill Down Videos</b-link>
    </div>

    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
            <!-- TBD error component. -->
          </b-alert>

          <div class="div-section-body" style="padding: 0 5px 5px 5px;">
              <div class="mt-2">
                  <b-row class="pb-2">
                      <b-col>

                          <div v-if="showVideo" class="mt-2 mb-4" >
                              <vue-plyr ref="plyr">
                              <div class="yt-container">
                                  <!-- https://developers.google.com/youtube/iframe_api_reference -->
                                  <iframe
                                  :src="getVideoUrl"
                                  allowfullscreen allowtransparency>
                                  </iframe>
                              </div>
                              </vue-plyr>
                          </div>

                          <h3>{{drilldownObj.title}}</h3>
                          <div>
                              {{drilldownObj.author}}
                              &bull;
                              {{drilldownObj.datePosted | prettyDateMin }}
                              &bull;
                              5-Minute Drill Down
                          </div>
                          <div class="mt-2" v-bind:inner-html.prop="this.drilldownObj.description"></div>

                          <bannerAd v-if="hasAd" :b="bannerAd"></bannerAd>

                      </b-col>
                  </b-row>
              </div>

              <hr size=1>

              <div v-if="posts.length !== 0" class="mt-2">
                <!-- <div class="mb-1 font-weight-bold">Recent Dental Blog Posts</div> -->
                <h5>Recent 5-Minute Drill Downs</h5>
                <ul>
                  <li v-for="(row) in posts" v-bind:key="row.id"><b-link :to="`/drilldown/${row.slug}`">{{row.title}}</b-link></li>
                </ul>
              </div>

          </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service"
import utils from "@/utils/utils"
import BannerAd from "@/components/BannerAd"

export default {
  name: "Drilldown",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      loading: true,
      msg: "Drilldown",
      studentHash: this.$root.getToken(),
      drilldownObj: {title: null, author: null, photo: null, body: null},
      posts: [],
      bannerAd: null,
      showVideo: false,
      posts: [],
      player: null,
      playerCounter: 0,
      playerTimer: null
    }
  },
  props: {
    // route set to use props mapped to url parameters
    drilldownId: {
      type: String,
      default: '0'
    },
    nolog: {
      type: String,
      default: null
    },
  },
  computed: {
    getVideoUrl() {
      let code = utils.getYoutubeCode(this.drilldownObj.youtubeUrl)
      let url = utils.getYoutubeUrl(code, true)
      if (this.debug) console.log(`drilldown getVideoUrl: ${url}`)
      return url
    },
    hasAd() {
      return (this.bannerAd !== null)
    }
  },
    components: {
    'bannerAd': BannerAd,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    clearPlayerTimer() {
      // if defined clear timer to get the vue plyr.
      if (this.playerTimer) window.clearInterval(this.playerTimer)
      this.playerTimer = null
    },
    playerEvents () { // load player events
      if (this.debug) {
        console.log(`playerEvents this.$refs`, this.$refs)
        console.log(`playerEvents this.$refs.plyr`, this.$refs.plyr)
      }

      if (!this.$refs.plyr) {
        this.playerCounter++
        if (this.playerCounter > 40) {
          this.clearPlayerTimer()
          this.bail('Timed out loading video.')   // TBD
        }
        if (this.debug) console.log(`${this.playerCounter}) NO PLAYER`)
        if (!this.playerTimer) {
          // Takes about 3 seconds for plyr to appear in $refs.
          this.playerTimer = window.setInterval( (function () { this.playerEvents() }).bind(this), 300 )
        }
        return
      }
      else {
        if (this.debug) console.log(`${this.playerCounter}) PLAYER FOUND`)
        this.clearPlayerTimer()
      }

      this.player = this.$refs.plyr.player
      // 'statechange','ready','canplay','error','progress','playing','play','pause','ended'
      this.player.on('statechange', ((e) => {
        // e.detail.code
        // -1 – unstarted
        // 0 – ended   YT.PlayerState.ENDED
        // 1 – playing  YT.PlayerState.PLAYING
        // 2 – paused  YT.PlayerState.PAUSED
        // 3 – buffering  YT.PlayerState.BUFFERING
        // 5 – video cued  YT.PlayerState.CUED   (not issued)
        if (this.debug) console.log(`Youtube event code: ${e.detail.code}`)
        switch (e.detail.code) {
            case YT.PlayerState.ENDED:
                this.ended()
                break
            case YT.PlayerState.PLAYING:
                this.logPlay()
                break
        }
      }).bind(this))
    },
    ended() {
        if (this.debug) console.log(`video ended`)
    },
    logPlay() {
      if (this.debug) console.log('logPlay')
      service
        .drilldownView(this.drilldownObj.hash, this.studentHash)
        .then(
          (res => {
            if (this.debug) console.log(res)
            if (res.status) {
              // not much to do...?
            }
            else {
              this.error = true
              this.errorMsg = 'Error logging drilldown play.'
            }
          }).bind(this)
        )
        .finally(e => {
          if (this.debug) console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System error. Logging API failure.'
          console.log(e)
        })
    },
    bail(msg) {
      this.error = true
      this.errorMsg = msg
    }
  },
  async created() {
    if (this.debug) console.log(`drilldownId: ${this.drilldownId}`)
    if (this.debug) console.log(`studentHash: ${this.studentHash}`)
    if (this.drilldownId) {
        this.loading = true

        // VP passes 'nolog' if ad view already recorded
        let blockLog = (this.nolog === 'nolog') ? 1 : 0;  // 1(true) block logging

        service
        .getDrilldown(this.drilldownId, this.studentHash, blockLog)
        .then(
            (res => {
              if (this.debug) console.log(res)
              if (res.status) {
                  this.drilldownObj = res.drilldownObj
                  if (this.debug) console.log(`title: ${this.drilldownObj.title}`)
                  this.bannerAd = res.bannerAd
                  this.posts = res.data   // Other drilldowns
                  this.showVideo = true
              }
              else {
                  this.error = true
                  this.errorMsg = "Server error. Try later."
              }
            }).bind(this)
        )
        .finally(e => {
            this.loading = false
            if (this.debug) console.log(`finally...`);
        })
        .catch(e => {
            this.error = true
            this.errorMsg = "Error accessing API."
            console.log(e)
        })
    }
    else {
        // flag error!
        this.error = true
        this.errorMsg = "Go back and select drill down."
    }
  },
  mounted () {
    if (this.debug) console.log('mounted')
    this.playerEvents()
  },
  beforeDestroy() {
    if (this.debug) console.log(`destroyed`)
  },
  destroy() {
    this.showVideo = false
    this.bannerAd = null
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.yt-container {
  position:relative;
  padding-bottom:56.25%;
  padding-top:30px;
  height:0;
  overflow:hidden;
  border: 2px solid green;
  width:100% !important;
  height:100% !important;
}
.yt-container iframe, .yt-container object, .yt-container embed {
  position:absolute;
  top:0;
  left:0;
  border: 1px solid red;
  width:100% !important;
  height:100% !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Drilldown.vue